<template>
  <div class="signing-wait-container">
    <div class="wait-card">
      <van-loading type="spinner" color="#1989fa" size="28px" />
      <h2>正在完成合同签署</h2>
      <p>请稍候，不要关闭页面...</p>
    </div>
  </div>
</template>
<script>
import requestHTAPI from '@/axios/HantangTax'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SigningWait',
  computed: {
    ...mapGetters([
      'getContractData',
      'getSignatureData'
    ])
  },
  mounted () {
    this.startSigning()
  },
  methods: {
    ...mapActions([
      'clearAllContractData'
    ]),
    async startSigning () {
      try {
        const contract = this.getContractData
        const sig = this.getSignatureData
        if (!contract || !sig) {
          this.$toast && this.$toast.fail('签署数据缺失，请返回重新操作')
          setTimeout(() => {
            this.$router.push('/mine/contract')
          }, 1000)
          return
        }

        this.$toast && this.$toast.loading({ message: '签署中...', duration: 0 })

        const params = {
          base64: sig || '',
          dataList: contract?.dataList || [],
          id: contract?.id || ''
        }
        const res = await requestHTAPI.fxqTwoStep(params)

        this.$toast && this.$toast.clear(true)

        if (res.data.code === '0000') {
          this.$toast && this.$toast.success('合同签署成功')
          this.clearAllContractData()
          setTimeout(() => {
            this.$router.push('/')
          }, 1200)
        } else {
          this.$toast && this.$toast.fail(res.data.message || '合同签署失败')
          setTimeout(() => {
            this.$router.push('/mine/contract')
          }, 1200)
        }
      } catch (error) {
        console.error('签署等待页签署异常:', error)
        this.$toast && this.$toast.fail('签署过程异常，请重试')
        setTimeout(() => {
          this.$router.push('/mine/contract')
        }, 1200)
      }
    }
  }
}
</script>
<style scoped>
.signing-wait-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f7f8fa;
}
.wait-card {
  text-align: center;
  background: #fff;
  padding: 24px 30px;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.06);
}
.wait-card h2 {
  margin: 12px 0 6px;
  font-size: 18px;
}
.wait-card p {
  color: #969799;
  font-size: 14px;
}
</style>
